<template lang="pug">
    div
        v-card-text
            .headline.mb-3(
                    :class="{'blue--text': activePaymentSelector}"
                )
                span Forma de pago (F7)
            PaymentTypeSelector(
                ref="paymentTypeSelector"
                :types="filteredPaymentMethodsList"
                @select="selectPaymentMethod($event)"
                :lock="paymentMethod"
                @active="activePaymentSelector = $event"
                )
            //v-select.title#payment-method(label="Seleccione forma de pago"
                ref="paymentMethod"
                :items="paymentMethodsList"
                item-text="text"
                item-value="id"
                v-model="paymentMethod"
                @input="clearPayment")

        v-card-text(v-if="payMethSelected")
            div(v-if="paymentMethod===1")
                // Cash payment
                cash-payment(@confirm="addPayment")
            div(v-else-if="paymentMethod===4")
                //Check payment
                check-payment(@confirm="addPayment")
            div(v-else-if="paymentMethod===5 && payer === 'SE'")
                //Descuento Planilla
                PayRollDeduction(@confirm="addPayment")
            div(v-else-if="paymentMethod===5 && payer === 'SC'")
                // Crédito Cliente
                customer-credit-payment(@confirm="addPayment")
            div(v-else-if="paymentMethod===6")
                // Bank transfer
                bank-transfer-payment(@confirm="addPayment")
            div(v-else-if="paymentMethod===8")
                // Bank transfer
                credit-note-payment(
                    @confirm="addPayment"
                    :isInvoice="posSaleType === 2"
                    )
            div(v-else-if="paymentMethod")
                //Transbank payment (debit or credit)
                transbank-payment(:key="paymentMethod" @confirm="addPayment")
            v-divider

        v-card-actions
            v-spacer
            v-btn.white--text.body-1.font-weight-light#add-payment-button(color="green darken-1" round
                @click='addPayment' @keyup.enter='addPayment'
                :disabled="!allDataSet") Confirmar pago 
           
</template>

<script>
//Components:
import CashPayment from './PaymentMethods/CashPayment'
import TransbankPayment from './PaymentMethods/TransbankPayment'
import CheckPayment from './PaymentMethods/CheckPayment'
import BankTransferPayment from './PaymentMethods/BankTransferPayment'
import CustomerCreditPayment from './PaymentMethods/CustomerCreditPayment'
import CreditNotePayment from './PaymentMethods/CreditNotePayment'
import PayRollDeduction from './PaymentMethods/PayRollDeduction'
import PaymentTypeSelector from './PaymentTypeSelector'

import { mapState, mapActions, mapGetters } from 'vuex'

//Services:
import { timeout } from '@/services/AsyncUtils'

export default {
    name: 'payment',
    props: {},
    data: function() {
        return {
            paymentMethod: null,
            activePaymentSelector: false,
        }
    },
    computed: {
        ...mapState('CashDeskModule', {
            total: state => state.total,
            totalInvoice: state => state.totalInvoice,
            payment: state => state.payment,
            posSaleType: state => state.posSaleType,
            paymentDetail: state => state.paymentDetail,
            payer: 'payer',
            arrayPayments: 'arrayPayments',
        }),
        ...mapState('CustomerModule', {
            customerData: state => state.customerData,
        }),
        ...mapGetters('CustomerModule', ['activeCustomerCredit']),
        ...mapGetters('CashDeskModule', {
            change: 'change',
            allDataSet: 'allDataSet',
            totalToPay: 'totalToPay',
            totalPaid: 'totalPaid',
        }),

        ...mapState('SnackbarModalModule', {
            showSnackbar: 'showSnackbar',
        }),

        payMethSelected() {
            return this.paymentMethod !== ''
        },

        cashPayment() {
            return this.paymentMethod === 'Efectivo'
        },

        changeText() {
            if (this.payment < this.total || this.total === 0) {
                return '-'
            } else {
                return this.change
            }
        },
        filteredPaymentMethodsList() {
            return this.paymentMethodsList.filter(m =>
                [2, 3].includes(m.id)
                    ? !this.arrayPayments.find(p =>
                          [2, 3].includes(p.paymentMethod)
                      )
                    : true
            )
        },
        paymentMethodsList() {
            // REFACTORIZAR ESTE COMPUTED PARA QUE SEA MÁS CORTO usando métodos push de arrays y esas cosas
            let cashPayment = false //only cash
            let otherPayment = false //planilla, debit, credit, check
            this.arrayPayments.forEach(element => {
                if (element.paymentMethod == 1) {
                    cashPayment = true
                } else {
                    otherPayment = true
                }
            })

            if (this.payer == 'SC') {
                // SC: Sale to Client
                if (
                    this.posSaleType === 2 && // factura
                    (this.arrayPayments === null ||
                        this.arrayPayments.length === 0) // no hay pagos registrado
                ) {
                    // FACTURA y que se no se haya hecho ningún pago hasta el momento

                    if (this.totalToPay > 9) {
                        // es posible pagar con efectivo
                        let payments = [
                            { text: 'Efectivo', id: 1 },
                            { text: 'Débito', id: 2 },
                            { text: 'Crédito', id: 3 },
                            { text: 'Cheque', id: 4 },
                            {
                                text: 'Factura a crédito (Crédito Cliente)',
                                id: 5,
                            },
                            { text: 'Transferencia bancaria', id: 6 },
                            { text: 'Nota de crédito', id: 8 },
                        ]
                        if (
                            this.activeCustomerCredit &&
                            this.activeCustomerCredit.max_customer_credit &&
                            this.totalInvoice >
                                this.activeCustomerCredit.max_available_credit
                        )
                            return payments.filter(p => p.id !== 5)
                        return payments
                    } else {
                        // no es posible pagar con efectivo
                        let payments = [
                            { text: 'Débito', id: 2 },
                            { text: 'Crédito', id: 3 },
                            { text: 'Cheque', id: 4 },
                            {
                                text: 'Factura a crédito (Crédito Cliente)',
                                id: 5,
                            },
                            { text: 'Transferencia bancaria', id: 6 },
                            { text: 'Nota de crédito', id: 8 },
                        ]
                        if (
                            this.activeCustomerCredit &&
                            this.activeCustomerCredit.max_customer_credit &&
                            this.totalInvoice >
                                this.activeCustomerCredit.max_available_credit
                        )
                            return payments.filter(p => p.id !== 5)
                        return payments
                    }
                } else if (this.totalToPay > 9) {
                    return [
                        { text: 'Efectivo', id: 1 },
                        { text: 'Débito', id: 2 },
                        { text: 'Crédito', id: 3 },
                        // { text: 'Cheque', id: 4 },
                        { text: 'Transferencia bancaria', id: 6 },
                        { text: 'Nota de crédito', id: 8 },
                    ]
                } else {
                    return [
                        { text: 'Débito', id: 2 },
                        { text: 'Crédito', id: 3 },
                        // { text: 'Cheque', id: 4 },
                    ]
                }
            } else {
                // SE: Sale to Employee
                if (cashPayment == true) {
                    return [{ text: 'Efectivo', id: 1 }]
                } else if (otherPayment == true) {
                    return [
                        //{ text: 'Débito', id: 2 },
                        //{ text: 'Crédito', id: 3 },
                        // { text: 'Cheque', id: 4 },
                        { text: 'Descuento Planilla', id: 5 },
                        //{ text: 'Transferencia bancaria', id: 6 },
                    ]
                } else {
                    return [
                        { text: 'Efectivo', id: 1 },
                        //{ text: 'Débito', id: 2 },
                        //{ text: 'Crédito', id: 3 },
                        // { text: 'Cheque', id: 4 },
                        { text: 'Descuento Planilla', id: 5 },
                        //{ text: 'Transferencia bancaria', id: 6 },
                    ]
                }
            }
        },
    },
    methods: {
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        ...mapActions('CashDeskModule', {
            resetCashDeskState: 'resetCashDeskState',
            setPaymentMethod: 'setPaymentMethod',
            submitSale: 'submitSale',
            clearPayment: 'clearPayment',
            savePayment: 'savePayment',
        }),

        addPayment() {
            this.savePayment()
            this.paymentMethod = ''
            this.$nextTick(() => this.$refs.paymentTypeSelector.focus())
        },
        cleanForm() {
            this.resetCashDeskState()
            this.$emit('clean-form')
        },
        annulSale() {
            this.resetSnackbarState()
            this.setMessageConfirmSnack(ANNUL_SALE_ACTION)
            let payload = {
                typeMessage: 'info',
                message: {
                    title: '¿Deseas anular la venta?',
                    body:
                        'Una vez anulada la venta no podras acceder a la información',
                },
                timeout: 10000,
                showProgress: false,
                showCloseBtn: true,
                closeBtnMessage: 'cerrar',
            }
            this.initSnackbar(payload)
            setTimeout(this.resetSnackbarState, 10001)
        },
        selectPaymentMethod(id) {
            this.paymentMethod = id
            this.clearPayment()
        },
    },
    watch: {
        /**
         * @description when payment method is changed, it has to be updated in store.
         */
        paymentMethod: function(newVal, oldVal) {
            this.setPaymentMethod(newVal)
        },
    },
    components: {
        CashPayment,
        TransbankPayment,
        CheckPayment,
        BankTransferPayment,
        CustomerCreditPayment,
        PayRollDeduction,
        PaymentTypeSelector,
        CreditNotePayment,
    },
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    mounted: function() {
        //this.setPaymentMethod(1)
        this.$nextTick(() => this.$refs.paymentTypeSelector.focus())
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss"></style>
